import { useState } from "react";
import { ArrowRight, CheckCircle, LockKey } from "@phosphor-icons/react";
import { Link, useSearchParams } from "react-router-dom";

import BrandLogo from "@/components/BrandLogo";
import { api, formatApiError } from "@/lib/api";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = searchParams.get("token");

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (password !== confirmation) {
      setError("Passwords do not match.");
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await api.post("/auth/reset-password", { token, password });
      setMessage(response.data.message);
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="recovery-screen" data-testid="reset-password-page">
      <section className="recovery-panel">
        <BrandLogo testId="reset-password-brand-logo" variant="form" />
        <p className="eyebrow">Account recovery</p>
        <h1 data-testid="reset-password-heading">Choose a new password</h1>
        <p>Use at least eight characters and keep this password private.</p>
        {!token ? (
          <p className="form-error" data-testid="missing-reset-token-error">This reset link is incomplete.</p>
        ) : message ? (
          <div className="recovery-message" data-testid="reset-password-success-message">
            <CheckCircle aria-hidden="true" size={25} weight="fill" />
            <p>{message}</p>
          </div>
        ) : (
          <form className="auth-form" onSubmit={submit} data-testid="reset-password-form">
            <label htmlFor="new-password">New password</label>
            <div className="password-field">
              <LockKey aria-hidden="true" size={20} />
              <input
                id="new-password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                minLength="8"
                autoComplete="new-password"
                required
                data-testid="reset-password-input"
              />
            </div>
            <label htmlFor="confirm-password">Confirm password</label>
            <div className="password-field">
              <LockKey aria-hidden="true" size={20} />
              <input
                id="confirm-password"
                type="password"
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                minLength="8"
                autoComplete="new-password"
                required
                data-testid="confirm-password-input"
              />
            </div>
            {error && <p className="form-error" role="alert" data-testid="reset-password-error">{error}</p>}
            <button className="primary-button" disabled={isSubmitting} data-testid="reset-password-submit">
              {isSubmitting ? "Updating" : "Update password"}
              <ArrowRight aria-hidden="true" size={19} weight="bold" />
            </button>
          </form>
        )}
        <Link className="back-to-login-link" to="/login" data-testid="reset-back-to-login-link">Back to sign in</Link>
      </section>
    </main>
  );
}